import { TmrBaseResource } from 'stylewhere/api'

export class Printers extends TmrBaseResource {
  static endpoint = 'api/v1/printers' //edge
}
